import { useRouter } from "next/router"
import SectionHalSlider from "@components/global/SectionHalfSlider"
import { Q_POSTS_BY_TYPE } from "lib/query"
import { linkOurCommitment } from "src/helper/page-url"
import { useFetchAPI } from "src/hooks/hooks"
import { convertHtmlToReact, convertJson, imgUrl } from "src/mixins"

export default function OurCommitmentSustain({ data, locale }) {
  const variables = {
    type: "REPORT",
    first: 100,
    categoryId: 38,
    orderBy: [
      {
        column: `report_year`,
        order: "DESC",
      },
    ],
  }
  if (!variables.reportYear) delete variables.reportYear
  const {
    data: reports,
    loading,
    error,
    refetch,
  } = useFetchAPI(Q_POSTS_BY_TYPE, { ...variables })
  return (
    <SectionHalSlider
      sectionName="sc-our-commitment-sustain"
      data={convertJson(data?.items)?.map((item) => ({
        label: data[`section_title_${locale}`],
        title: item[`title_${locale}`],
        text: convertHtmlToReact(item[`description_${locale}`]),
        img: imgUrl(item.image),
        link: `${linkOurCommitment}/sustainability-commitment`,
      }))}
      reports={reports?.posts?.data}
      loadingReports={loading}
      errorReports={error}
    />
  )
}
